import { Route, Routes } from "react-router-dom";

import Login from "./components/user/entralogin";
import LoginError from "./components/user/loginError";
import LoginSuccess from "./components/user/loginSuccess";
import OutputReview from "./components/wedge-builder/OutputBuilder";
import PermanentIssueRegister from "./components/wedge-builder/permanent-issue-register";
import WBHome from "./components/wedge-builder/wb-home";
import Protected from "./shared/protected-routing";

/*
moduleId is 'wedge' or else

*/
export const routes = [
	<Routes key="routes-1">
		<Route exact path="/" Component={Login} />
		<Route exact path="/success" Component={LoginSuccess} />
		<Route exact path="/login-error" Component={LoginError} />

		<Route
			exact
			path="/:moduleId/wb-home"
			element={
				<Protected component={"wb-home"}>
					<WBHome />
				</Protected>
			}
		/>

		<Route
			exact
			path="/:moduleId/wb-output-review/:caseID/:requestID"
			element={
				<Protected component={"wb-output-review"}>
					<OutputReview />
				</Protected>
			}
		/>

		<Route
			exact
			path="/:moduleId/permanent-issue-register"
			element={
				<Protected component={"permanent-issue-register"}>
					<PermanentIssueRegister />
				</Protected>
			}
		/>
	</Routes>,
];
